module.exports = __webpack_public_path__ + "img/installed_flange_with_nuts_and_bolts.3254e57c.webp";